import { Box } from "@mui/material";

const YammerUsers = () => {
    return ( 
        <Box sx={{marginLeft:"10px"}}>
        <iframe
          src="https://docs.google.com/spreadsheets/d/e/2PACX-1vRojf9-K5OkoTsPgWvVHXLUlnE_4B0bYQezilv3m25uDVT3EVMnjz-ri12YZryY3Q/pubhtml?gid=1394333249&amp;single=true&amp;widget=true&amp;headers=false"
          width="1072"
          height="520"
        ></iframe>
      </Box>
     );
}
 
export default YammerUsers;